export default {"src":"/_next/static/media/icon.a5772e60.svg","height":1024,"width":1024};